import { toAppService } from "@/api/app"
import { isMyApp } from "@/utils/util"
import { type, navigateTo } from "@/utils/app-router"

export function toService(id) {
  // 没有id直接返回
  if (!id) return
  // app跳转
  if (isMyApp) return toAppService(id)
  // 小程序跳转
  if (type) return navigateTo(`/pages/service-detail/index?id=${id}`)
  // 网页跳转
  if (location.href.includes === 'm.lichenglove.com') {
    window.location.href = `https://m.lichenglove.com/service/${id}`
  } else {
    window.location.href = `https://licheng-mobile.weddingee.com/service/${id}`
  }
}